<table
	[attr.data-exportable]="exportable ? '' : undefined"
	[dataSource]="dataToRender"
	[ngClass]="{ 'rows-clickable': model.rowsClickable }"
	cdk-table
	class="cdk-table"
	cdkDropList
	cdkDropListOrientation="horizontal"
	(cdkDropListDropped)="drop($event, model.columnDefs)"
>
	@if (model.columns(); as columns) {
		@for (column of columns; track column; let c = $index; let first = $first) {
			@if (model.getColumnDef(column); as columnDef) {
				<ng-container cdkColumnDef="{{ column }}" [sticky]="columnDef.sticky">
					@switch (columnDef.header.headerType) {
						@case ("default") {
							<th
								cdk-header-cell
								*cdkHeaderCellDef
								[ngClass]="columnDef.header.class"
								[ngStyle]="columnDef.header.style"
								(click)="clickSort(column, columnDef.sortable)"
								[class.sort-enabled]="columnDef.sortable"
							>
								@if (columnDef.sortable) {
									<span
										class="sort-icon"
										[class.sort-active]="sortActive === column"
										data-princexml-ignore
										data-html2canvas-ignore
										[appTooltip]="'Sortering ' + (sortDirection === 'asc' ? 'oplopend' : 'aflopend')"
									>
										<app-icon
											[name]="sortActive === column && sortDirection === 'desc' ? 'sorteren-aflopend' : 'sorteren-oplopend'"
											color="typography-3"
											size="small"
										></app-icon>
									</span>
								}
								<app-cell-content [model]="model" [cellDef]="columnDef.header"></app-cell-content>
							</th>
						}
						@case ("groepering") {
							<th
								cdk-header-cell
								*cdkHeaderCellDef
								[ngClass]="columnDef.header.class"
								[ngStyle]="columnDef.header.style"
								class="flex-groepering-header"
							>
								<div class="groepering-group" [class.sort-active]="sortActive === column" [class.first]="first">
									<div
										class="flex-groepering"
										[ngClass]="'groepering-' + column.replace('.', '-')"
										[class.change-groups]="columnDef.changeGroups"
										[class.active]="groupingMenuActive() === column"
										[class.first]="first"
										[class.batch]="columnDef.header.batchGroepering"
										[class.sort-active]="sortActive === column"
										[class.locked]="columnDef.locked"
										(click)="groupingMenuActive.set(column)"
										cdkDrag
										cdkDragLockAxis="x"
										[cdkDragDisabled]="columnDef.sticky"
										#groepering
									>
										<div *cdkDragPreview>
											<app-cell-content [model]="model" [cellDef]="columnDef.header"></app-cell-content>
										</div>
										<div *cdkDragPlaceholder>
											<app-cell-content [model]="model" [cellDef]="columnDef.header"></app-cell-content>
										</div>
										@if (sortActive === column) {
											<span
												class="sort-icon sort-active"
												(click)="clickSort(column, true)"
												data-princexml-ignore
												data-html2canvas-ignore
												[appTooltip]="'Sortering ' + (sortDirection === 'asc' ? 'oplopend' : 'aflopend')"
											>
												<app-icon
													[name]="sortDirection === 'desc' ? 'sorteren-aflopend' : 'sorteren-oplopend'"
													color="typography-3"
													size="small"
												></app-icon>
											</span>
										}
										@if (groupingMenuActive() === column) {
											<div class="meatball-above">
												<app-icon name="meatball-menu" color="typography-5" size="tiny"></app-icon>
											</div>
										}
										<app-cell-content [model]="model" [cellDef]="columnDef.header"></app-cell-content>
										@if (groupingMenuActive() === column) {
											<div class="header-icon" data-princexml-ignore data-html2canvas-ignore>
												<app-icon name="chevron-up" color="primary-1" size="smallest"></app-icon>
											</div>
										} @else if (columnDef.locked) {
											<div class="header-icon" data-princexml-ignore data-html2canvas-ignore>
												<app-icon name="pinned" color="primary-1" size="smallest"></app-icon>
											</div>
										} @else if (groupingMenuActive() !== column) {
											<div class="header-icon" data-princexml-ignore data-html2canvas-ignore>
												<app-icon name="chevron-down" color="typography-5" size="smallest"></app-icon>
											</div>
										}
									</div>
									@if (columnDef.header.batchGroepering && isGroeperingAvailable()) {
										<div
											class="flex-groepering add groepering-addGroup"
											[class.active]="groupingMenuActive() === 'addGroup'"
											(click)="groupingMenuActive.set('addGroup')"
											#groepering
											data-princexml-ignore
											data-html2canvas-ignore
										>
											<app-icon name="toevoegen" color="typography-3" size="small"></app-icon>
										</div>
									}
								</div>
							</th>
						}
						@case ("addGroup") {
							<th
								cdk-header-cell
								*cdkHeaderCellDef
								[ngClass]="columnDef.header.class"
								[ngStyle]="columnDef.header.style"
								class="flex-groepering-header"
							>
								@if (isGroeperingAvailable()) {
									<div class="groepering-group">
										<div
											class="flex-groepering add groepering-addGroup"
											[class.active]="groupingMenuActive() === column"
											(click)="groupingMenuActive.set(column)"
											#groepering
											data-princexml-ignore
											data-html2canvas-ignore
											appTooltip="Groepering toevoegen"
										>
											<app-icon name="toevoegen" color="typography-3" size="small"></app-icon>
										</div>
									</div>
								}
							</th>
						}
					}
					<td
						cdk-cell
						*cdkCellDef="let row; let r = index"
						[ngClass]="columnDef.body.class"
						[class.row-hover]="r === hoverR"
						[class.column-hover]="c === hoverC"
						[ngStyle]="columnDef.body.style"
						(mouseenter)="onHover(r, c)"
						(mouseleave)="onHover(undefined, undefined)"
						(click)="onClickedBodyCell(row, columnDef.body.clickHandler, $event)"
						[attr.rowspan]="columnDef.body.getRowspan(row)"
						[style.display]="columnDef.body.getRowspan(row) === 0 ? 'none' : ''"
						[class.clickable]="columnDef.body.clickHandler"
						[class.locked]="columnDef.locked"
					>
						<app-cell-content [model]="row" [cellDef]="columnDef.body"></app-cell-content>
					</td>
					<td
						cdk-footer-cell
						*cdkFooterCellDef
						(click)="onClickedFooterCell(model, columnDef.footer.clickHandler, $event)"
						[ngClass]="columnDef.footer.class"
						[ngStyle]="columnDef.footer.style"
						(mouseenter)="onHover('footer', c)"
						(mouseleave)="onHover(undefined, undefined)"
						[class.row-hover]="'footer' === hoverR"
						[class.column-hover]="c === hoverC"
						[class.clickable]="columnDef.footer.clickHandler"
						[class.locked]="columnDef.locked"
					>
						<app-cell-content [model]="model" [cellDef]="columnDef.footer"></app-cell-content>
					</td>
				</ng-container>
			}
		}

		<ng-container cdkColumnDef="spinner">
			<td cdk-footer-cell *cdkFooterCellDef>
				@if (dataToRender | async; as currentData) {
					@if (currentData.length < model.data.length) {
						<div class="spinner"><span class="one">.</span><span class="two">.</span><span class="three">.</span></div>
					}
				}
			</td>
		</ng-container>

		@if (model.showExtraFooters) {
			@for (column of columns; track column; let c = $index) {
				@if (model.getColumnDef(column); as columnDef) {
					<ng-container cdkColumnDef="{{ x_column(column) }}" [sticky]="columnDef.sticky">
						<td
							cdk-footer-cell
							*cdkFooterCellDef
							(click)="onClickedFooterCell(model, columnDef.extraFooter?.clickHandler, $event)"
							[ngClass]="columnDef.extraFooter?.class ?? ''"
							[ngStyle]="columnDef.extraFooter?.style ?? null"
							(mouseenter)="onHover('extraFooter', c)"
							(mouseleave)="onHover(undefined, undefined)"
							[class.row-hover]="'extraFooter' === hoverR"
							[class.column-hover]="c === hoverC"
							[class.locked]="columnDef.locked"
						>
							@if (columnDef.extraFooter) {
								<app-cell-content [model]="model" [cellDef]="columnDef.extraFooter!"></app-cell-content>
							}
						</td>
					</ng-container>
				}
			}
		}

		@if (model.showHeaders) {
			<tr cdk-header-row *cdkHeaderRowDef="columns" [class.sticky]="model.stickyHeaders"></tr>
		}

		<tr
			cdk-row
			class="connect-table-row"
			*cdkRowDef="let row; columns: columns"
			[id]="model.getRowId(row)"
			[class.alternating-odd]="model.alternating === AlternatingMode.COLOR && model.getRowgroup && model.getRowgroup(row).groupId % 2 === 0"
			[class.alternating-even]="model.alternating === AlternatingMode.COLOR && model.getRowgroup && model.getRowgroup(row).groupId % 2 === 1"
			[class.alternating-line]="model.alternating === AlternatingMode.LINE && model.getRowgroup && model.getRowgroup(row).lastOfGroup"
			[class]="model.getRowgroup?.(row)?.class"
		></tr>

		<tr cdk-footer-row *cdkFooterRowDef="['spinner']" class="tableEnd"></tr>

		@if (model.showExtraFooters) {
			<tr cdk-footer-row *cdkFooterRowDef="x_columns(columns)" [class.sticky]="model.stickyFooters" class="extra-footer"></tr>
		}

		@if (model.showFooters) {
			<tr cdk-footer-row *cdkFooterRowDef="columns" [class.sticky]="model.stickyFooters"></tr>
		}
	}
</table>
